import React, { useState, useEffect } from "react";
import { useLanguage } from "../../utils/languageContext.js";
import { getTranslation } from "../../utils/translate.js";

const LegalInfo = ({ chefData }) => {
    const [formData, setFormData] = useState({
        legalNameAm: "",
        legalNameEn: "",
        legalNameRu: "",
        taxNumber: "",
        bankAccount: "",
    });
    const { language } = useLanguage();

    useEffect(() => {
        if (chefData) {
            const { legalNameAm, legalNameEn, legalNameRu, taxNumber, bankAccount } = chefData;
            setFormData({
                legalNameAm: legalNameAm || "",
                legalNameEn: legalNameEn || "",
                legalNameRu: legalNameRu || "",
                taxNumber: taxNumber || "",
                bankAccount: bankAccount || "",
            });
        }
    }, [chefData]);

    // Function to handle copy to clipboard
    const copyToClipboard = (text, fieldName) => {
        navigator.clipboard.writeText(text).then(() => {
            // Show temporary copied message
            const element = document.getElementById(`copy-${fieldName}`);
            if (element) {
                element.classList.remove('hidden');
                setTimeout(() => {
                    element.classList.add('hidden');
                }, 2000);
            }
        });
    };

    return (
        <div className="mt-4">
            <div className="bg-white dark:bg-[#161b22] rounded-lg border border-gray-200 dark:border-[#30363d] p-6 mb-6 pb-8 shadow-sm">
                <div className="flex flex-wrap gap-6">
                    <div className="w-full sm:w-[286px]">
                        <label className="text-sm font-bold block text-fontColor dark:text-[#c9d1d9] mb-2">
                            {getTranslation('profile.legalNameAm', language)}
                        </label>
                        <div className="px-4 py-2 bg-gray-50 dark:bg-[#0d1117] text-gray-900 dark:text-[#c9d1d9] text-sm border border-gray-300 dark:border-[#30363d] rounded-md">
                            {formData.legalNameAm || '-'}
                        </div>
                    </div>
                    <div className="w-full sm:w-[286px]">
                        <label className="text-sm font-bold block text-fontColor dark:text-[#c9d1d9] mb-2">
                            {getTranslation('profile.legalNameEn', language)}
                        </label>
                        <div className="px-4 py-2 bg-gray-50 dark:bg-[#0d1117] text-gray-900 dark:text-[#c9d1d9] text-sm border border-gray-300 dark:border-[#30363d] rounded-md">
                            {formData.legalNameEn || '-'}
                        </div>
                    </div>
                    <div className="w-full sm:w-[286px]">
                        <label className="text-sm font-bold block text-fontColor dark:text-[#c9d1d9] mb-2">
                            {getTranslation('profile.legalNameRu', language)}
                        </label>
                        <div className="px-4 py-2 bg-gray-50 dark:bg-[#0d1117] text-gray-900 dark:text-[#c9d1d9] text-sm border border-gray-300 dark:border-[#30363d] rounded-md">
                            {formData.legalNameRu || '-'}
                        </div>
                    </div>
                    <div className="w-full sm:w-[286px]">
                        <label className="text-sm font-bold block text-fontColor dark:text-[#c9d1d9] mb-2">
                            {getTranslation('profile.bankAccount', language)}
                        </label>
                        <div className="px-4 py-2 bg-gray-50 dark:bg-[#0d1117] text-gray-900 dark:text-[#c9d1d9] text-sm border border-gray-300 dark:border-[#30363d] rounded-md">
                            {formData.bankAccount || '-'}
                </div>
            </div>
                    <div className="w-full sm:w-[286px]">
                        <label className="text-sm font-bold block text-fontColor dark:text-[#c9d1d9] mb-2">
                            {getTranslation('profile.tin', language)}
                        </label>
                        <div className="px-4 py-2 bg-gray-50 dark:bg-[#0d1117] text-gray-900 dark:text-[#c9d1d9] text-sm border border-gray-300 dark:border-[#30363d] rounded-md flex items-center justify-between">
                            <span>{formData.taxNumber || '-'}</span>
                            {formData.taxNumber && (
                                <button
                                    onClick={() => copyToClipboard(formData.taxNumber, 'taxNumber')}
                                    className="ml-2 text-gray-500 dark:text-[#8b949e] hover:text-gray-700 dark:hover:text-[#c9d1d9] transition-colors"
                                    title={getTranslation('common.copy', language) || 'Copy'}
                                >
                                    <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                    </svg>
                                </button>
                            )}
                        </div>
                        <span id="copy-taxNumber" className="hidden text-xs text-green-600 dark:text-green-400 mt-1">{getTranslation('common.copied', language) || 'Copied!'}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LegalInfo;
